var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var BulmaDropdown = /** @class */ (function (_super) {
    __extends(BulmaDropdown, _super);
    function BulmaDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = false;
        return _this;
    }
    BulmaDropdown.prototype.onBodyClick = function (e) {
        var target = e.target;
        if (target != this.$el && !this.$el.contains(target)) {
            this.isActive = false;
        }
    };
    BulmaDropdown.prototype.mounted = function () {
        document.body.addEventListener('click', this.onBodyClick);
    };
    BulmaDropdown.prototype.destroyed = function () {
        document.body.removeEventListener('click', this.onBodyClick);
    };
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], BulmaDropdown.prototype, "buttonClassNames", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], BulmaDropdown.prototype, "disabled", void 0);
    BulmaDropdown = __decorate([
        Component
    ], BulmaDropdown);
    return BulmaDropdown;
}(Vue));
export default BulmaDropdown;
